<template>
  <div class="p-20">

    <van-form ref="form" :show-error="false" error-message-align="right">
      <van-cell-group>
        <van-field v-f-show="'flowNo'" :required="isRequired('flowNo')" v-model="formData.flowNo"
                   :rules="getRules('flowNo')" label="编号" input-align="right" readonly/>
        <van-field v-f-show="'ssxm'" input-align="right" name="ssxm" :required="isRequired('ssxm')"
                   :value="formData.ssxm" :rules="getRules('ssxm')" label="所属项目" placeholder="请选择项目">
          <template #input>
            <view-item @click.native="isShowPopup(ssxm,'ssxm')" :value="formData.ssxm" placeholder="请选择项目"/>
            <van-popup v-model="ssxm.show" position="bottom">
              <van-nav-bar title="选择项目" left-text="取消" right-text="确定" @click-left="ssxm.show = false"
                           @click-right="popupSubmitSsxm('ssxm',{label:'projectName',value:'projectId'})"/>
              <van-search v-model="ssxm.filterText" @input="pickerSearch($event,ssxm,'projectName')" clearable
                          shape="round"/>
              <van-picker :duration="0" ref="ssxm" value-key="projectName" :columns="ssxm.filteredData"
                          @cancel="ssxm.show = false"/>
            </van-popup>
          </template>
        </van-field>

        <van-field v-f-show="'qjlx'" input-align="right" name="qjlx" :required="isRequired('qjlx')"
                   :value="formData.qjlx" label="请假类型" :rules="getRules('qjlx')" placeholder="请选择请假类型">
          <template #input>
            <view-item @click.native="isShowPopup(qjlx,'qjlx')" :value="formData.qjlx" placeholder="请选择请假类型"/>
            <van-popup v-model="qjlx.show" position="bottom">
              <van-nav-bar title="选择请假类型" left-text="取消" right-text="确定" @click-left="qjlx.show = false"
                           @click-right="popupSubmit('qjlx')"/>
              <van-search v-model="qjlx.filterText" @input="pickerSearch($event,qjlx)" clearable shape="round"/>
              <van-picker ref="qjlx" value-key="label" :columns="qjlx.filteredData" @cancel="qjlx.show = false"/>
            </van-popup>
          </template>
        </van-field>

        <van-field v-f-show="'qjsj'" :value="formData.qjsj[0]" :required="isRequired('qjsj')" name="qjsj"
                   label="请假开始时间" placeholder="请假开始时间" input-align="right" :rules="getRules('qjsj')">
          <template #input>
            <view-item @click.native="isShowPopup(qjsjStart,'qjsj')"
                       :value="formData.qjsj[0]  ?`${formData.qjsj[0]}` : ''" placeholder="请假开始时间"/>
            <van-popup v-model="qjsjStart.show" position="bottom">
              <van-nav-bar title="选择请假开始时间" left-text="取消" right-text="确定"
                           @click-left="qjsjStart.show = false" @click-right="qjsjStartChange"/>
              <van-datetime-picker ref="qjsjStart" :show-toolbar="false" v-model="qjsjStart.currentDate" type="datetime"
                                   title="选择完整时间"/>
            </van-popup>
          </template>
        </van-field>

        <van-field v-f-show="'qjsj'" :value="formData.qjsj[1]" :required="isRequired('qjsj')" name="qjsj"
                   label="请假结束时间" placeholder="请假结束时间" input-align="right" :rules="getRules('qjsj')">
          <template #input>
            <view-item @click.native="isShowPopup(qjsjEnd,'qjsj')" :value="formData.qjsj[1] ?`${formData.qjsj[1]}` : ''"
                       placeholder="请假结束时间"/>
            <van-popup v-model="qjsjEnd.show" position="bottom">
              <van-nav-bar title="选择请假结束时间" left-text="取消" right-text="确定"
                           @click-left="qjsjEnd.show = false" @click-right="qjsjEndChange('qjsj')"/>
              <van-datetime-picker :show-toolbar="false" ref="qjsjEnd" v-model="qjsjEnd.currentDate" type="datetime"
                                   title="选择完整时间"/>
            </van-popup>
          </template>
        </van-field>

        <van-field v-f-show="'qjsc'" v-model="formData.qjsc" :readonly="isDisabled('qjsc')" type="number"
                   :required="isRequired('qjsc')" :rules="getRules('qjsc')" name="qjsc" maxlength="50" autosize
                   label="请假时长(天)" placeholder="请输入请假时长" input-align="right"/>
        <van-field v-f-show="'qjsy'" v-model="formData.qjsy" :readonly="isDisabled('qjsy')"
                   :required="isRequired('qjsy')" name="qjsy" :rules="getRules('qjsy')" type="textarea" maxlength="200"
                   rows="3" autosize label="请假事由" show-word-limit placeholder="请输入请假事由" input-align="right"/>
        <van-field class="fileValueBox" v-f-show="'fj'" :value.prop="formData.fj" input-align="right" name="fj" :required="isRequired('fj')"
                   :rules="getRules('fj')" label="附件" placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="isDisabled('fj')" :files="formData.fj" @success="uploadSuccess"
                         module-type="flow"     @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','fj')"></uploadFiles>
          </template>
        </van-field>
      </van-cell-group>
    </van-form>
    <div class="font-32 font-weight-500 cor-00 m-t-26">流程</div>
    <!--      这个是不带选人的流程图    -->
    <flowTrace v-if="!$route.query.reSend && (processInstanceId || $route.query.processInstanceId)" class="m-t-20"
               :flowTraceList="flowTrace" :processInfo="processData"></flowTrace>
    <!--      这个是带选人的流程图    -->
    <approver v-else class="m-t-20" ref="approver" @addUser="addUser" :processData="processData" :formData="formData" :formItemMap="formItemMap"/>
    <bottom-bar @submit="submit" @mention="mention"></bottom-bar>
    <van-popup position="bottom" v-model="approver.show">
      <van-nav-bar title="选择办理人" left-text="取消" right-text="确定" @click-left="approver.show = false"
                   @click-right="approverPopupSubmit"/>
      <van-search v-model="approver.filterText" @input="treeSearch($event, $refs.approverTree)" clearable
                  shape="round"/>
      <div style="overflow-y: auto" class="h-vh-50">
        <div class="p-10">
          <el-tree ref="approverTree" @check-change="approverCheckChange($event, $refs.approverTree)" node-key="uuid"
                   check-strictly :data="approver.data" :filter-node-method="filterNode" check-on-click-node
                   show-checkbox/>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {getDeptUserTreeAll, selectMyProjectList} from '@/api/user.js'
import {getFormDataByInstanceId} from "@/api/flow";
import {getDictDataByType} from '@/api/dict'
import cache from "@/plugins/cache";
import mixin from '@/mixin/flow'
import moment from "moment";
import uploadFiles from "@/components/uploadFiles/index.vue";
import fileMixins from "@/components/uploadFiles/fileMixins";
import bottomBar from '@/components/flow/bottom-bar.vue'
import flowTrace from '@/components/flow/flowTrace.vue'
import approver from "@/components/flow/approver.vue";
import store from "@/store";

export default {
  components: {approver, flowTrace, bottomBar, uploadFiles},
  mixins: [mixin,fileMixins],
  created() {
    const {templateId, groupId, reSend} = this.$route.query
    this.SET_TEMPLATE_ID(templateId)
    this.SET_GROUP_ID(groupId)
    this.init()
    if (reSend && this.$route.query.processInstanceId) { // 重新发起时
      this.$loading.show()
      this.getFormInfo({templateId: this.templateId}).then(res => {
        this.formItemMap = new Map( res.data?.currentNode?.props?.formPerms.map(item => [item.id, item]))
        // 从后台去流程表单数据 只取fomData
        getFormDataByInstanceId(this.$route.query.processInstanceId).then(form => {
          // 合并
          Object.assign(this.formData, res.data.processTemplates.expressVals, form.data)
          this.$loading.hide()
        })
      })
    } else if (this.$route.query.processInstanceId && !this.$route.query.reSend) { // 外部跳转时
      this.SET_PROCESS_INSTANCE_ID(this.$route.query.processInstanceId)
      if (this.$route.query.taskId) {
        this.SET_TASK_ID(this.$route.query.taskId)
      }
      this.$loading.show()
      this.getProcessInfo({
        processInstanceId: this.$route.query.processInstanceId,
        taskId: this.$route.query.taskId
      }).then(res => {
        Object.assign(this.formData, res.data.formData)
        this.$loading.hide()
      })
    } else { // 新增时
      // 新增时调用
      this.getFormInfo({templateId: this.templateId, groupId: this.groupId}).then(res => {
        this.formItemMap = new Map( res.data?.currentNode?.props?.formPerms.map(item => [item.id, item]))
        Object.assign(this.formData, res.data.processTemplates.expressVals)
      })
      // 新增时 初始化的时候预定人是当前登录用户
      const currentUserInfo = JSON.parse(cache.session.get("userInfo"))
      this.formData.ssbm = currentUserInfo.dept.deptName
      this.selectMyProjectList(currentUserInfo)
    }
  },
  data() {
    return {
      moment,
      formData: {
        flowNo: '',
        ssxm: '', // 所属项目
        qjsc: '',// 请假时间
        qjlx: '',// 请假类型
        qjsy: '',// 请假事由
        qjsj: [],// 请假时间
        ssbm: '', // 所属部门
        fj: [],// 附件
      },
      rules: {},
      // 所属项目
      ssxm: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      // 请假类型
      qjlx: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      qjsjStart: {
        show: false,
        currentDate: moment().toDate(),
      },
      qjsjEnd: {
        show: false,
        currentDate: moment().toDate(),
      },
      // 选人树
      approver: {
        data: [],
        filterText: '',
        show: false
      },
      // 部门用户树
      deptUserTreeAll: {
        data: [],
        filterText: '',
        show: false
      },
      formItemMap: null, // 表单字段的Map
    }
  },
  methods: {
    // 进页面就调用
    init() {
      // 获取部门用户树
      this.getDeptUserTreeAll()
      getDictDataByType('flow_furlough_type').then(res => {
        const data = res.data.map(item => {
          return item.dictLabel
        })
        this.qjlx.data = data
        this.qjlx.filteredData = data
      })
    },
    qjsjStartChange() {
      this.formData.qjsj[0] = moment(this.$refs.qjsjStart.value).format('YYYY-MM-DD HH:mm')
      // 设置结束时间的最小值和最大值
      this.qjsjEnd.minDate = moment(this.$refs.qjsjStart.value).add(1,'minutes').toDate()
      this.qjsjEnd.maxDate = moment(this.$refs.qjsjStart.value).add(1, 'years').toDate()
      this.qjsjStart.show = false;
    },
    qjsjEndChange() {
      this.formData.qjsj[1] = moment(this.$refs.qjsjEnd.value).format('YYYY-MM-DD HH:mm')
      // 设置开始时间的最大值和最小值
      this.qjsjStart.maxDate = moment(this.$refs.qjsjEnd.value).toDate()
      this.qjsjStart.minDate = moment(this.$refs.qjsjEnd.value).subtract(1, 'years').toDate()
      this.qjsjEnd.show = false;

    },
    uploadSuccess(fileList) { // 每次都会filelist全部丢出来
      this.formData.fj = fileList
    },
    qjsjConfirm(date) {
      this.formData.qjsj = date.map(item => {
        return moment(item).format('YYYY-MM-DD HH:mm')
      });
      console.log(this.formData.qjsj)
      // 计算 this.formData.qjsc  两个时间的差值 以天为单位
      const start = moment(this.formData.qjsj[0])
      const end = moment(this.formData.qjsj[1])
      const duration = end.diff(start, 'days')
      this.formData.qjsc = duration
      this.qjsj.show = false;
    },
    // 人员、部门树
    getDeptUserTreeAll() {
      const _this = this
      getDeptUserTreeAll().then(res => {
        // 递归处理this.deptUserTreeAll，添加禁用状态和uuid
        const data = this._getDeptUserTreeAll(res.data[0].children)
        this.$nextTick(() => {
          this.$set(this.deptUserTreeAll, 'data', data)
          this.$set(this.approver, 'data', data)
        })
      })
    },
    // 获取人员所属项目列表
    selectMyProjectList(user) {
      return new Promise(resolve => {
        selectMyProjectList({projectMember: user.id || user.userId}).then(res => {
          this.ssxm.data = res.rows
          this.ssxm.filteredData = res.rows
          resolve(res.rows)
        })
      })
    },
  }
}
</script>
